const SERVER_TIMEZONE_OFFSET_MINUTES = 7 * 60;
const PAYMENT_EXPIRE_MINUTES = 30;

const hasTimezone = value => /(?:z|[+-]\d{2}:?\d{2})$/i.test(value);

export const parseServerDateTime = value => {
  if (value === null || value === undefined) return null;

  const rawValue = String(value).trim();
  if (!rawValue || rawValue === '0') return null;

  if (/^-?\d+$/.test(rawValue)) {
    const numericValue = Number(rawValue);
    if (!Number.isFinite(numericValue) || numericValue <= 0) return null;
    return numericValue < 100000000000 ? numericValue * 1000 : numericValue;
  }

  if (hasTimezone(rawValue)) {
    const timestamp = Date.parse(rawValue);
    return Number.isNaN(timestamp) ? null : timestamp;
  }

  const matched = rawValue.match(
    /^(\d{4})[-/](\d{1,2})[-/](\d{1,2})(?:[ T](\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?(?:\.(\d{1,3}))?)?$/
  );
  if (matched) {
    const [, year, month, day, hour = '0', minute = '0', second = '0', millisecond = '0'] = matched;
    const utcTime = Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
      Number(millisecond.padEnd(3, '0'))
    );
    return utcTime - SERVER_TIMEZONE_OFFSET_MINUTES * 60 * 1000;
  }

  const timestamp = Date.parse(rawValue);
  return Number.isNaN(timestamp) ? null : timestamp;
};

export const getPaymentExpireTime = createTime => {
  const createTimestamp = parseServerDateTime(createTime);
  if (!createTimestamp) return null;
  return createTimestamp + PAYMENT_EXPIRE_MINUTES * 60 * 1000;
};

export const getPaymentRemainingSeconds = (createTime, now = Date.now()) => {
  const expireTime = getPaymentExpireTime(createTime);
  if (!expireTime) return PAYMENT_EXPIRE_MINUTES * 60;
  return Math.max(0, Math.floor((expireTime - now) / 1000));
};
